// extracted by mini-css-extract-plugin
var _1 = "RequestBoard-moduleRequestBoard__G2jJ6";
var _2 = "RequestBoard-modulecolumns__PRF6t";
var _3 = "RequestBoard-modulenoDrop__SXJON";
var _4 = "RequestBoard-moduleoverlay__CWX4N";
export { _1 as "RequestBoard", _2 as "columns", _3 as "noDrop", _4 as "overlay" }
